
































import Vue from "vue";
import ResizeObserver from "resize-observer-polyfill";
// @ts-ignore
import echarts from "echarts";

const LineConfig = {
  legend: {
    data: [""],
    left: 10
  },
  tooltip: {
    trigger: "axis"
  },
  grid: {
    left: 0,
    right: 20,
    top: 15,
    bottom: 10,
    containLabel: true
  },
  xAxis: {
    type: "time",
    axisTick: {
      show: false
    },
    axisLine: {
      lineStyle: {
        color: "rgba(207,207,207,1)"
      }
    },
    axisLabel: {
      color: "rgb(0,0,0)"
      // formatter: function(value: string) {
      //   return value.split(" ")[1];
      // }
    }
  },
  yAxis: {
    type: "value",
    boundaryGap: false,
    axisTick: {
      show: false
    },
    axisLine: {
      show: false
    },
    axisLabel: {
      color: "rgba(99,102,107,1)"
    },
    splitLine: {
      lineStyle: {
        color: "rgba(233,233,233,1)",
        type: "dashed"
      }
    }
  },
  color: ["#40E0D0"]
};
const stepOption = [
  { label: "10分钟", value: "10m" },
  { label: "30分钟", value: "30m" },
  { label: "1小时", value: "1h" },
  { label: "1天", value: "24h" }
];
export default Vue.extend({
  name: "InfoLine",
  props: {
    title: { type: String, default: "" },
    data: { type: Array, default: () => [] as Array<any> },
    loading: { type: Boolean },
    action: { type: Function }
  },
  data() {
    return {
      date: [] as Array<Date>,
      step: "10m",
      stepOption,
      chart: null as any,
      observer: (null as any) as ResizeObserver,
      timer: 0
    };
  },
  mounted() {
    this.init();
    this.getData();
  },
  beforeDestroy() {
    clearTimeout(this.timer);
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    init() {
      const start = new Date();
      const end = new Date();

      start.setTime(start.getTime() - 3600 * 1000 * 2);
      // 默认选中 近两小时
      this.date = [start, end];
      // 初始化 chart
      this.chart = echarts.init(this.$refs.chart);
      this.chart.setOption(LineConfig);
      // 监听 chart 变化
      this.observer = new ResizeObserver(() => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.chart.resize();
        }, 200);
      });
      this.observer.observe(this.$refs.chart as HTMLElement);
    },
    getData() {
      if (!this.action) return;
      const start = (this.date[0]?.getTime() / 1000).toFixed(0);
      const end = (this.date[1]?.getTime() / 1000).toFixed(0);
      if (!start || !end) return;

      this.action({
        start,
        end,
        step: this.step
      }).then(() => {
        this.$nextTick(() => {
          // 绘制图表
          this.chart.setOption({
            series: [
              {
                type: "line",
                smooth: 0.6,
                showSymbol: false,
                lineStyle: {
                  width: 2
                },
                data: this.data
              }
            ]
          });
        });
      });
    },
    getDefaultData() {
      const now = new Date().getTime();
      switch (this.step) {
        case "10m":
          this.$set(this, "date", [
            new Date(now - 12 * 3600 * 1000),
            new Date(now)
          ]);
          break;
        case "30m":
          this.$set(this, "date", [
            new Date(now - 24 * 3600 * 1000),
            new Date(now)
          ]);
          break;
        case "1h":
          this.$set(this, "date", [
            new Date(now - 48 * 3600 * 1000),
            new Date(now)
          ]);
          break;
        case "24h":
          this.$set(this, "date", [
            new Date(now - 24 * 7 * 3600 * 1000),
            new Date(now)
          ]);
          break;
      }
      this.getData();
    }
  }
});
